import { Messages } from '../../../codegen/Localize';
import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

export const remoteRefreshSortOptions: OptionsDictionary = {
  [OrderKeys.refreshType]: {
    id: OrderKeys.refreshType,
    getMenuItemDisplayValue: Messages.column_task_type,
    subSortOptions: {
      'asc': {
        id: 'refreshType.asc',
        field: OrderKeys.refreshType,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.refreshType)]
      },
      'desc': {
        id: 'refreshType.desc',
        field: OrderKeys.refreshType,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.refreshType)]
      }
    }
  },
  [OrderKeys.definition]: {
    id: OrderKeys.definition,
    getMenuItemDisplayValue: Messages.column_remote_schedule_definition,
    subSortOptions: {
      'asc': {
        id: 'definition.asc',
        field: OrderKeys.definition,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.definition)]
      },
      'desc': {
        id: 'definition.desc',
        field: OrderKeys.definition,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.definition)]
      }
    }
  },
  'lastRunAt' : SortOptions.lastRunAt,
  'runNextAt' : SortOptions.runNextAt
};
